import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";
import { useI18n } from "../i18n";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const { setLang } = useI18n();
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { setUser(false); return false; }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => { if (user && user.ui_lang && !localStorage.getItem("pf_lang")) setLang(user.ui_lang); }, [user, setLang]);
  const logout = async () => { try { await api.post("/auth/logout"); } catch { /* ignore */ } setUser(false); };
  return <Ctx.Provider value={{ user, setUser, refresh, logout }}>{children}</Ctx.Provider>;
}
export const useAuth = () => useContext(Ctx);

export function Protected({ children, role }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-16 text-center muted" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (role && user.role !== role && user.role !== "admin") return <div className="p-16 text-center" data-testid="forbidden">You do not have access to this area.</div>;
  return children;
}
